import { render, staticRenderFns } from "./Base600Black.vue?vue&type=template&id=32861154&scoped=true&"
var script = {}
import style0 from "./Base600Black.vue?vue&type=style&index=0&id=32861154&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32861154",
  null
  
)

export default component.exports